// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imageHover {
    color: var(--primaryColor);
}

.imageHover:hover {
    cursor: zoom-in;
    font-weight: bold;
}

.MuiTooltip-tooltip {
    background: transparent;
}

.orderRow:hover {
    cursor: pointer;
    background-color: whitesmoke;
}

.downloadLink {
    color: var(--primaryColor);
    text-decoration: underline;
    cursor: pointer;
}

.downloadLink:hover {
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderManagement.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".imageHover {\n    color: var(--primaryColor);\n}\n\n.imageHover:hover {\n    cursor: zoom-in;\n    font-weight: bold;\n}\n\n.MuiTooltip-tooltip {\n    background: transparent;\n}\n\n.orderRow:hover {\n    cursor: pointer;\n    background-color: whitesmoke;\n}\n\n.downloadLink {\n    color: var(--primaryColor);\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.downloadLink:hover {\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
